import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { StyledFlex } from '@dreryk/react-components';

import { ConsentsAndAuthorizations } from './ConsentsAndAuthorizations/ConsentsAndAuthorizations';
import { MedicalConsentAndAuthorizationsPrintAction } from './MedicalConsentAndAuthorizationsPrintAction/MedicalConsentAndAuthorizationsPrintAction';
import { MedicalDataAccessAuthorizationPanel } from './MedicalDataAccessAuthorizationPanel/MedicalDataAccessAuthorizationPanel';
import { MedicalTreatmentConsentSection } from './MedicalTreatmentConsentSection/MedicalTreatmentConsentSection';

type ConsentsAndAuthorizationsPanelProps = {
   readonly patient: Patient;
};

const ConsentsAndAuthorizationsPanel = (props: ConsentsAndAuthorizationsPanelProps): JSX.Element => {
   return (
      <StyledFlex gap={40} direction={'column'}>
         <MedicalTreatmentConsentSection patientId={props.patient.id} />
         <ConsentsAndAuthorizations patientId={props.patient.id} />
         <MedicalDataAccessAuthorizationPanel patientId={props.patient.id} />
         <MedicalConsentAndAuthorizationsPrintAction patient={props.patient} />
      </StyledFlex>
   );
};

export { ConsentsAndAuthorizationsPanel };
